'use strict';

class SideBarController {

	constructor($scope, $element, $timeout) {
		this.$scope 		= $scope;
		this.element 		= $element.get(0);
		this.$timeout 		= $timeout;
		this.mainTopCtrl 	= $scope.mainTopCtrl;
		this.openedItem 	= null;
		
		this._initialize();
	}

	_onClickElement (buttonInfo, obj, event) {
		if (!buttonInfo.enabled)
			return;
		if (this._hasSubMenu(buttonInfo)) {
			this._closeOpenedItem(buttonInfo);
		}
		this.$timeout(() => {
			if (this._hasSubMenu(buttonInfo)) {
				this._toggleSubMenu(buttonInfo);
			}
			else{
				this.mainTopCtrl.onClickElement(buttonInfo, obj, event);
			}
		}, this.openedItem && this.openedItem != buttonInfo ? 300 : 0);
	}

	initElement(buttonInfo) {
		if (!buttonInfo.enabled)
			return;
		let target = this.element.querySelector('.listItem#obj'+buttonInfo.id);
		this.mainTopCtrl.doInit(buttonInfo, target);
	}
	
	_getButtons (buttonsInfo) {
	
		let buttons = {
			home 			: buttonsInfo.home,
			create 			: buttonsInfo.create,
			spacesGroup 	: buttonsInfo.spacesGroup,
			contents	 	: buttonsInfo.contents,
			users		 	: buttonsInfo.users,
			managementGroup : buttonsInfo.managementGroup,
			favourites		: buttonsInfo.favourites,
			recents			: buttonsInfo.recents,
			streams 		: buttonsInfo.streams,
			templates 		: buttonsInfo.templates,
			administration	: buttonsInfo.administration,
			themeSettings	: buttonsInfo.themeSettings,
			helpGroup 		: buttonsInfo.helpGroup,
			templatesMaster : buttonsInfo.templatesMaster
		};

		buttons.home.hasDivider 			= true;
		buttons.managementGroup.hasDivider 	= true;	
		
		return buttons;
	}

	_toggleSubMenu(buttonInfo) {
		buttonInfo.opened = !buttonInfo.opened;
		this.openedItem	= buttonInfo.opened ? buttonInfo : null;
	}

	_hasSubMenu(buttonInfo) {
		return buttonInfo.subItems != undefined;
	}
	
	_closeOpenedItem(buttonInfo) {
		if(this.openedItem && (buttonInfo != this.openedItem || !this._hasSubMenu(buttonInfo))){
			this.openedItem.opened 	= false;
		}
	}
	
	_initializeVM () {
		let userButtonsInfo = this.mainTopCtrl.data.userButtonsInfo;
		this.buttons = this._getButtons(userButtonsInfo);
	}
	
	_updateVM () {
		this._initializeVM();
	}
	
	_initialize(){
		this.mainTopCtrl.attachOnChangeListener(() => {
			this._updateVM();
		});
		this._initializeVM();
	}
}
